export default "__VITE_ASSET__ca8ISvm9__"